import { fetchTimeline } from '../services/timeline';

const PATIENT_TIMELINE_PAGE_LIMIT = 50;

export function patientTimelineQuery(patientId: string) {
    return {
        queryKey: ['patient-timeline', patientId] as const,
        queryFn: () =>
            fetchTimeline(patientId, { isLatest: true, limit: PATIENT_TIMELINE_PAGE_LIMIT })
    };
}
